import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { addToEndOfChain, Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    GetProductCollectionApiV2Parameter,
    ProductExpandTokens,
} from "@insite/client-framework/Services/ProductServiceV2";
import {
    chain,
    DisplayProductsResult,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import { dispatchProductImpressions } from "@store/Framework/Services/AnalyticsService";
import { PrepageProductRecs } from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import prepareCategory from "@insite/client-framework/Store/Components/ProductRecommendations/Handlers/PrepareCategory";
import {
    getProductListDataViewProperty,
} from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import prepareBrand from "@insite/client-framework/Store/Components/ProductRecommendations/Handlers/PrepareBrand";
import prepareSearchResultPage from "@insite/client-framework/Store/Components/ProductRecommendations/Handlers/PrepareSearchResultPage";

const enum pageType {
    productListPage = "Product List Page",
    searchPage = "Search Page",
}

interface Parameter {
    queryString: string;
    path: string;
    isSearch: boolean;
}
interface Props {
    apiParameter: GetProductCollectionApiV2Parameter;
    idByPath?: SafeDictionary<string>;
    result: DisplayProductsResult;
    pricingLoaded?: true;
    expandTokens?: ProductExpandTokens;
}

type HandlerType = Handler<Parameter, Props>;

export const CustomPrepageProductRecs: HandlerType = ({
    getState,
    dispatch,
    parameter: { isSearch },
    result: { catalogPage, products },
}) => {
    const state = getState();

    if (catalogPage && !isSearch && !catalogPage.brandId) {
        dispatch(prepareCategory({ catalogPage }));
    }

    if (products) {
        if (isSearch) {
            const pagination = getProductListDataViewProperty(state, "pagination");
            const attributeTypeFacets = getProductListDataViewProperty(state, "attributeTypeFacets");
            const originalQuery = getProductListDataViewProperty(state, "originalQuery");
            dispatch(prepareSearchResultPage({ products, pagination, attributeTypeFacets, originalQuery }));
        } else if (catalogPage && !isSearch && catalogPage.brandId) {
            const brandFacets = getProductListDataViewProperty(state, "brandFacets");
            if (brandFacets) {
                dispatch(prepareBrand({ brandFacets }));
            }
        }
    }
};

const dispatchProductImpressionsChain: HandlerType = props => {
    const state = props.getState();
    const currency = state.context.session.currency?.currencyCode;
    const { isSearch } = props.parameter;
    const { products } = props.result;
    let page = pageType.productListPage;

    if (isSearch) {
        page = pageType.searchPage;
    }
    if (products && products?.length > 0) {
        dispatchProductImpressions(products, currency, page);
    }
};

replaceInChain(chain, PrepageProductRecs, CustomPrepageProductRecs);
addToEndOfChain(chain, dispatchProductImpressionsChain); // Absolunet Custom Code
